// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style_status__rYn1Y {
  color: #ffc107;
  font-size: 12px;
  font-weight: 500;
  margin: 0px;
  display: flex;
  padding: 4px 8px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: var(--rs_yellow_10, #fff9e7);
  white-space: pre;
}

.style_new__2BZKk {
  color: #757575;
  background: #f5f5f5;
}

.style_inProgress__VkviC {
  color: #ffc107;
  background: #fff9e7;
}

.style_contacted__0ljpC {
  color: #220d77;
  background: #e9e7f2;
}

.style_hired__iWQi7 {
  color: #e6f6ec;
  background: #00a43b;
}

.style_rejected__zoHhg {
  color: #fff1ef;
  background: #d84315;
}

.style_spam__6y4OX {
  color: #fff1ef;
  background: lightgray;
}

.style_synced__b6pky {
  color: #00a43b;
  background: #e6f6ec;
}

.style_TasksTable__EALF8,
.style_nameAndLogo__8ESL\\+ {
  display: flex;
  align-items: center;
}
.style_TasksTable__EALF8 p,
.style_nameAndLogo__8ESL\\+ p {
  margin: 0;
}
.style_TasksTable__EALF8 img,
.style_nameAndLogo__8ESL\\+ img {
  margin-right: 10px;
  border-radius: 5px;
}
.style_TasksTable__EALF8 .style_nameAndLogo__8ESL\\+ p,
.style_TasksTable__EALF8 .style_jobType__8PP1S p,
.style_nameAndLogo__8ESL\\+ .style_nameAndLogo__8ESL\\+ p,
.style_nameAndLogo__8ESL\\+ .style_jobType__8PP1S p {
  margin: 0;
}
.style_TasksTable__EALF8 .style_image-card__oMh4b img,
.style_nameAndLogo__8ESL\\+ .style_image-card__oMh4b img {
  border-radius: 10px;
}
.style_TasksTable__EALF8 .style_showFilesInvoice__cnOEa,
.style_nameAndLogo__8ESL\\+ .style_showFilesInvoice__cnOEa {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5%;
}
.style_TasksTable__EALF8 .style_fileCont__cOFTY,
.style_nameAndLogo__8ESL\\+ .style_fileCont__cOFTY {
  position: relative;
}
.style_TasksTable__EALF8 .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__sUS\\+b,
.style_nameAndLogo__8ESL\\+ .style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__sUS\\+b {
  align-items: baseline;
}
.style_TasksTable__EALF8 .style_statusOrders__lYKM\\+,
.style_nameAndLogo__8ESL\\+ .style_statusOrders__lYKM\\+ {
  display: flex;
  align-items: center;
}
.style_TasksTable__EALF8 .style_statusOrders__lYKM\\+ .style_space__0hN-h,
.style_nameAndLogo__8ESL\\+ .style_statusOrders__lYKM\\+ .style_space__0hN-h {
  margin-right: 5px;
}

.style_logo__9ht-A {
  width: 35px;
  margin-right: 1em;
}

.style_EnhancedTableToolbar__EFDJO .style_sortAndFilters__oq3ns {
  display: flex;
  justify-content: flex-end;
}

.style_filterDrawer__tzrdj .style_drawerContainer__moMMM {
  width: 20vw;
  min-width: 230px;
  margin-top: 60%;
}
.style_filterDrawer__tzrdj .style_drawerContainer__moMMM .style_header__e2qqQ {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.style_filterDrawer__tzrdj .style_drawerContainer__moMMM form > div {
  margin-top: 20px;
}
.style_filterDrawer__tzrdj .style_drawerContainer__moMMM .style_clearButt__uRo-r {
  margin-top: 20px;
  height: 3.5em;
}

@media (max-width: 768px) {
  * {
    font-size: 10px;
  }
}
.style_sortby__p7rEm {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 5px;
  width: fit-content;
  text-align: center;
  border-right: solid rgba(161, 158, 158, 0.5) 1px;
  border-left: solid rgba(161, 158, 158, 0.5) 1px;
}
.style_sortby__p7rEm label {
  margin-right: 10px;
  margin-left: 10px;
}
.style_sortby__p7rEm .style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__2yYYS:before {
  border-bottom: none;
}
.style_sortby__p7rEm #style_demo-simple-select__kczWF {
  margin-top: 3px;
}

.style_removeIcon__E2pgZ {
  cursor: pointer;
  transition: transform 0.2s;
}
.style_removeIcon__E2pgZ:hover {
  transform: scale(1.2);
}
.style_removeIcon__E2pgZ:active {
  transform: scale(0.9);
}

.style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__lzt-r:before {
  border-bottom: none;
}

.style_searchBy__EJiPo {
  border-left: none;
}`, "",{"version":3,"sources":["webpack://./src/components/TableRender/RowRender/Rows/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,oBAAA;EACA,wCAAA;EACA,gBAAA;AACF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAKA;EACE,cAAA;EACA,qBAAA;AAFF;;AAKA;EACE,cAAA;EACA,mBAAA;AAFF;;AAWA;;EAEE,aAAA;EACA,mBAAA;AARF;AASE;;EACE,SAAA;AANJ;AAQE;;EACE,kBAAA;EACA,kBAAA;AALJ;AAUI;;;;EACE,SAAA;AALN;AASE;;EACE,mBAAA;AANJ;AASE;;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AANJ;AASE;;EACE,kBAAA;AANJ;AASE;;EACE,qBAAA;AANJ;AASE;;EACE,aAAA;EACA,mBAAA;AANJ;AAOI;;EACE,iBAAA;AAJN;;AAQA;EACE,WAAA;EACA,iBAAA;AALF;;AASE;EACE,aAAA;EACA,yBAAA;AANJ;;AAWE;EAME,WAAA;EACA,gBAAA;EACA,eAAA;AAbJ;AAMI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAJN;AASI;EACE,gBAAA;AAPN;AASI;EACE,gBAAA;EACA,aAAA;AAPN;;AAYA;EACE;IACE,eAAA;EATF;AACF;AAWA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,kBAAA;EACA,kBAAA;EAEA,gDAlGW;EAmGX,+CAnGW;AAwFb;AAaE;EACE,kBAAA;EACA,iBAAA;AAXJ;AAaE;EACE,mBAAA;AAXJ;AAaE;EACE,eAAA;AAXJ;;AAeA;EACE,eAAA;EACA,0BAAA;AAZF;AAaE;EACE,qBAAA;AAXJ;AAaE;EACE,qBAAA;AAXJ;;AAeA;EACE,mBAAA;AAZF;;AAcA;EACE,iBAAA;AAXF","sourcesContent":[".status {\n  color: #ffc107;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 0px;\n  display: flex;\n  padding: 4px 8px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 100px;\n  background: var(--rs_yellow_10, #fff9e7);\n  white-space: pre;\n}\n\n.chanelChip {\n}\n\n.new {\n  color: #757575;\n  background: #f5f5f5;\n}\n\n.inProgress {\n  color: #ffc107;\n  background: #fff9e7;\n}\n\n.contacted {\n  color: #220d77;\n  background: #e9e7f2;\n}\n\n.hired {\n  color: #e6f6ec;\n  background: #00a43b;\n}\n\n.rejected {\n  color: #fff1ef;\n  background: #d84315;\n}\n\n.spam {\n  color: #fff1ef;\n  background: lightgray;\n}\n\n.synced {\n  color: #00a43b;\n  background: #e6f6ec;\n}\n\n$borderSide: solid\n  rgba(\n    $color: #a19e9e,\n    $alpha: 0.5,\n  )\n  1px;\n.TasksTable,\n.nameAndLogo {\n  display: flex;\n  align-items: center;\n  p {\n    margin: 0;\n  }\n  img {\n    margin-right: 10px;\n    border-radius: 5px;\n  }\n\n  .nameAndLogo,\n  .jobType {\n    p {\n      margin: 0;\n    }\n  }\n\n  .image-card img {\n    border-radius: 10px;\n  }\n\n  .showFilesInvoice {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 5%;\n  }\n\n  .fileCont {\n    position: relative;\n  }\n\n  .css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar {\n    align-items: baseline;\n  }\n\n  .statusOrders {\n    display: flex;\n    align-items: center;\n    .space {\n      margin-right: 5px;\n    }\n  }\n}\n.logo {\n  width: 35px;\n  margin-right: 1em;\n}\n\n.EnhancedTableToolbar {\n  .sortAndFilters {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.filterDrawer {\n  .drawerContainer {\n    .header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n    }\n    width: 20vw;\n    min-width: 230px;\n    margin-top: 60%;\n    form > div {\n      margin-top: 20px;\n    }\n    .clearButt {\n      margin-top: 20px;\n      height: 3.5em;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  * {\n    font-size: 10px;\n  }\n}\n.sortby {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-top: 5px;\n  width: fit-content;\n  text-align: center;\n\n  border-right: $borderSide;\n  border-left: $borderSide;\n\n  label {\n    margin-right: 10px;\n    margin-left: 10px;\n  }\n  .css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n    border-bottom: none;\n  }\n  #demo-simple-select {\n    margin-top: 3px;\n  }\n}\n\n.removeIcon {\n  cursor: pointer;\n  transition: transform 0.2s;\n  &:hover {\n    transform: scale(1.2);\n  }\n  &:active {\n    transform: scale(0.9);\n  }\n}\n\n.css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root:before {\n  border-bottom: none;\n}\n.searchBy {\n  border-left: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `style_status__rYn1Y`,
	"new": `style_new__2BZKk`,
	"inProgress": `style_inProgress__VkviC`,
	"contacted": `style_contacted__0ljpC`,
	"hired": `style_hired__iWQi7`,
	"rejected": `style_rejected__zoHhg`,
	"spam": `style_spam__6y4OX`,
	"synced": `style_synced__b6pky`,
	"TasksTable": `style_TasksTable__EALF8`,
	"nameAndLogo": `style_nameAndLogo__8ESL+`,
	"jobType": `style_jobType__8PP1S`,
	"image-card": `style_image-card__oMh4b`,
	"showFilesInvoice": `style_showFilesInvoice__cnOEa`,
	"fileCont": `style_fileCont__cOFTY`,
	"css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar": `style_css-teccuw-MuiToolbar-root-MuiTablePagination-toolbar__sUS+b`,
	"statusOrders": `style_statusOrders__lYKM+`,
	"space": `style_space__0hN-h`,
	"logo": `style_logo__9ht-A`,
	"EnhancedTableToolbar": `style_EnhancedTableToolbar__EFDJO`,
	"sortAndFilters": `style_sortAndFilters__oq3ns`,
	"filterDrawer": `style_filterDrawer__tzrdj`,
	"drawerContainer": `style_drawerContainer__moMMM`,
	"header": `style_header__e2qqQ`,
	"clearButt": `style_clearButt__uRo-r`,
	"sortby": `style_sortby__p7rEm`,
	"css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-1jewp7z-MuiInputBase-root-MuiInput-root-MuiSelect-root__2yYYS`,
	"demo-simple-select": `style_demo-simple-select__kczWF`,
	"removeIcon": `style_removeIcon__E2pgZ`,
	"css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root": `style_css-cl7x3o-MuiInputBase-root-MuiInput-root-MuiSelect-root__lzt-r`,
	"searchBy": `style_searchBy__EJiPo`
};
export default ___CSS_LOADER_EXPORT___;
